var _style, _ellipse, _ellipse2, _ellipse3, _line, _path, _path2, _path3, _path4, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBmi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A1D4A5;}\n\t.st1{fill:none;stroke:#020202;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 27.48,
    cy: 27,
    rx: 13.7,
    ry: 13.85
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 23.01,
    cy: 16.4,
    rx: 6.06,
    ry: 6.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 23.02,
    cy: 16.44,
    rx: 1.03,
    ry: 1.09
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23.02,
    y1: 15.35,
    x2: 23.01,
    y2: 11.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.19,24.47c0,0,0-2.04,0-5.24s-2.5-3.32-2.5-3.32h-2.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.71,24.47v-5.42c0,0-0.06-3.2,2.91-3.15c2.97,0.06,2.35,0,2.35,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,30.87c0,0-0.36-1.57-4.61-1.43s-23.53,0-23.53,0V24.7h25.86c0,0,2.04,0.12,2.27,2.16 c0.06,1.92,0,4.78,0,4.78s0.7,2.68-3.79,2.56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.52,29.47l0.76,5.65c0,0,0,3.38,2.97,3.32s12.82,0,12.82,0s3.38,0.17,3.67-2.51 c0.29-2.68,0.67-6.49,0.67-6.49"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.25,
    y1: 24.8,
    x2: 35.25,
    y2: 26.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 33.15,
    y1: 24.8,
    x2: 33.15,
    y2: 26.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 31.4,
    y1: 24.8,
    x2: 31.4,
    y2: 26.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 29.53,
    y1: 24.8,
    x2: 29.53,
    y2: 26.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 27.79,
    y1: 24.8,
    x2: 27.79,
    y2: 26.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 25.92,
    y1: 24.8,
    x2: 25.92,
    y2: 26.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 24.06,
    y1: 24.8,
    x2: 24.06,
    y2: 26.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 21.99,
    y1: 24.8,
    x2: 21.99,
    y2: 26.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 20.21,
    y1: 24.8,
    x2: 20.21,
    y2: 26.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 18.35,
    y1: 24.8,
    x2: 18.35,
    y2: 26.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 16.6,
    y1: 24.8,
    x2: 16.6,
    y2: 26.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.37,
    y1: 24.8,
    x2: 14.37,
    y2: 26.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.52,
    y1: 24.8,
    x2: 12.52,
    y2: 26.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.83,
    y1: 24.8,
    x2: 10.83,
    y2: 26.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmi);
export default __webpack_public_path__ + "static/media/BMI.9130d8b4a3df6bf9bf0738756efd38b3.svg";
export { ForwardRef as ReactComponent };